export default {
  ja: {
    TestData: {
      input: '私はただのインプット',
      p: '私はただのパラグラフ',
    },
    BusinessProfile: 'プロファイル',
    Settings: 'サイト設定',
    Btn: {
      login: 'ログイン',
      signup: '登録',
      email: 'メールアドレス',
      password: 'パスワード',
      backHome: 'ホームへ戻る',
      dateTime: '日時 >>',
      customerInfo: 'お客様情報 >>',
      goBack: '戻る',
      confirm: '確認 >>',
      reloadData: 'データ再読み込み',
      active: '使用中',
      inactive: '非使用',
      newMenu: '新規メニュー',
      update: '更新',
      clearForm: 'フォームクリア',
      activate: '使用中にする',
      deactivate: 'アカウント凍結',
      addCustomer: '新規顧客',
      customerId: '顧客ID',
      firstName: '姓',
      lastName: '名',
      history: '履歴',
      customerIndex: '顧客一覧',
      customerDetail: '顧客詳細',
      startOver: '初めに戻る',
      bookAppointment: '予約する',
      checkout: '支払う',
      profile: 'プロファイル',
      settings: 'サイト設定',
      updateProfile: 'プロファイル更新',
      updateSettings: 'サイト設定更新',
      cancel: 'キャンセル',
    },
    Currency: '¥',
    DateTime: {
      hour: '時間',
      min: '分',
      jan: '1月',
      feb: '2月',
      mar: '3月',
      apr: '4月',
      may: '5月',
      jun: '6月',
      jul: '7月',
      aug: '8月',
      sep: '9月',
      oct: '10月',
      nov: '11月',
      dec: '12月',
      months: "'1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'"
    },
    Locale: {
      locale: 'JPN',
      tax: '(NY)'
    },
    Home: {
      greeting: 'Welcome to Booking App Biznesu',
      message: 'ご利用にはログイン/ご登録が必要です。',
      loginAdmin: '管理者ログイン',
      loginUser: '一般ユーザーログイン',
      email: 'メールアドレス',
      password: 'パスワード',
    },
    Login: {
      pageTitle: 'ログイン',
      loginAdmin: '管理者ログイン',
      loginUser: '一般ユーザーログイン',
      form: {
        email: 'メールアドレス',
        password: 'パスワード',
      },
    },
    Appointments: {
      totalDuration: '合計時間',
      hour: '時間',
      min: '分',
      title: {
        pickMenu: 'メニュー選択',
        pickTime: '日時選択',
        customerInfo: 'お客様情報',
        confirmation: '確認',
      },
      steps: {
        menu: 'メニュー',
        dateTime: '日時',
        customerInfo: 'お客様情報',
        confirmation: '確認',
      },
      errors: {
        selectMenus: 'メニューを選択してください',
        selectDateTime: '日時を選択してください',
      }
    },
    Complete: {
      thankYou: "ご利用ありがとうございます。",
      linkNotice: "下記のリンクでご予約の確認ができます。(管理者のみ)",
      bookedNotice: "予約が完了しました。",
      rescheduleNotice: "ご予約の変更、キャンセルがありましたら下記連絡先にお知らせください。",
      cancelationNotice: "ご予約開始時間の24時間前以降はキャンセル料がかかる場合がございます。",
      anyCountry: 'どの国でも',
    },
    Calendar: {
      dontSeeAppointments: "",
    },
    Dashboard: {
      appointmentsByMenu: 'メニュー比率',
      salesByMenu: 'メニュー毎売上 (¥)',
      Charts: {
        appointments: '予約件数',
        sales: '売上',
        thisYear: '指定',
        prevYear: '次年',
        users: '顧客数',
        avarageSpent: '顧客売上平均',
      }
    },
    Spinner: {
      createAppointment: 'アカウント作成中',
      createAndLogin: 'アカウント作成中',
      loading: '読み込み中',
      loggingIn: 'ログイン中',
      collectingData: '読み込み中',
    },
    Forms: {
      name: '姓名',
      firstName: '姓',
      lastName: '名',
      email: 'メールアドレス',
      phone: '電話番号',
      gender: '性別',
      zip: '郵便番号',
      state: '都道府県',
      city: '市区町村',
      address: '以降の住所',
      requestsAndNote: 'ご要望など',
      note: 'ノート',
      appointmentDate: 'ご予約日',
      time: '時間',
      subtotal: '小計',
      tax: '消費税',
      total: '合計',
      title: 'タイトル',
      price: '金額',
      duration: '施術時間',
      description: '説明',
      country: '国',
      cardNumber: 'カード番号',
      exp: '有効期限',
      cvc: 'セキュリティ',
      businessName: '店舗名/屋号',
      website: 'ウェブサイト URL',
      instagram: 'Instagram URL',
      twitter: 'Twitter URL',
      facebook: 'Facebook URL',
      language: '言語',
      taxRate: '消費税率',
      calendarStartTime: 'カレンダーの開始時間',
      calendarEndTime: 'カレンダーの終了時間',
      intervalTime: '予約後の準備時間など (分)'
    },
    Messages: {
      couponNotice: 'クーポンをお持ちのお客様は施術開始前にスタッフにお知らせください。店頭での割引となります。',
      priceNotice: '表示された金額はお身体の状態によって変更になることがございます。',
      tearmsAndCondition: '利用規約',
      privacyPolicy: 'プラーバシー・ポリシー',
      agree: '同意する',
      and: 'と',
      tos: '利用規約',
      term: '私は xxx の{0}に同意します。',
      testModeNotice: 'テスト用のカードをお使いください',
    },
    Menus: {
      menu: 'メニュー',
      arms: '両腕',
      VIO: 'VIO',
      legs: '両脚',
  
    },
    Customers: {
      sortBy: '並び替え',
      customerDetail: '顧客詳細',
      history: '履歴',
      clickToSee: 'クリックで顧客詳細へ',
      statics: {
        totalAppointments: '施術回数',
        totalSpent: '売上合計',
        lastVisit: '最終予約日',
  
      }
    },
    Gender: {
      male: '男性',
      female: '女性',
      nonBinary: 'ノンバイナリー',
      ratherNot: 'その他',
      NA: '該当なし',
    },
    StatesUS: {
      AL: 'AL', AK: 'AK', AZ: 'AZ', AR: 'AR', CA: 'CA',
      CO: 'CO', CT: 'CT', DE: 'DE', FL: 'FL', GA: 'GA',
      HI: 'HI', ID: 'ID', IL: 'IL', IN: 'IN', IA: 'IA',
      KS: 'KS', KY: 'KY', LA: 'LA', ME: 'ME', MD: 'MD',
      MA: 'MA', MI: 'MI', MN: 'MN', MS: 'MS', MO: 'MO',
      MT: 'MT', NE: 'NE', NV: 'NV', NH: 'NH', NJ: 'NJ',
      NM: 'NM', NY: 'NY', NC: 'NC', ND: 'ND', OH: 'OH',
      OK: 'OK', OR: 'OR', PA: 'PA', RI: 'RI', SC: 'SC',
      SD: 'SD', TN: 'TN', TX: 'TX', UT: 'UT', VT: 'VT',
      VA: 'VA', WA: 'WA', WV: 'WV', WI: 'WI', WY: 'WY'
    },
    prefJPN: {
      hokkaido: '北海道',
      aomori: '青森県',
      iwate: '岩手県',
      miyagi: '宮城県',
      akita: '秋田県',
      yamagata: '山形県',
      fukushima: '福島県',
      ibaraki: '茨城県',
      tochigi: '栃木県',
      gunma: '群馬県',
      saitama: '埼玉県',
      chiba: '千葉県',
      tokyo: '東京都',
      kanagawa: '神奈川県',
      niigata: '新潟県',
      toyama: '富山県',
      ishikawa: '石川県',
      fukui: '福井県',
      yamanashi: '山梨県',
      nagano: '長野県',
      gifu: '岐阜県',
      shizuoka: '静岡県',
      aichi: '愛知県',
      mie: '三重県',
      shiga: '滋賀県',
      kyoto: '京都府',
      osaka: '大阪府',
      hyogo: '兵庫県',
      nara: '奈良県',
      wakayama: '和歌山県',
      tottori: '鳥取県',
      shimane: '島根県',
      okayama: '岡山県',
      hiroshima: '広島県',
      yamaguchi: '山口県',
      tokushima: '徳島県',
      kagawa: '香川県',
      ehime: '愛媛県',
      kochi: '高知県',
      fukuoka: '福岡県',
      saga: '佐賀県',
      nagasaki: '長崎県',
      kumamoto: '熊本県',
      oita: '大分県',
      miyazaki: '宮崎県',
      kagoshima: '鹿児島県',
      okinawa: '沖縄県',
    }
  }
}



